export enum LocationMenuItems {
  OVERVIEW = "overview",
  OUTBOUND = "outbound",
  STORAGE = "storage",
  INBOUND = "inbound"
};
